import { gql } from '@apollo/client';

import { documentFragment } from '../fragments';

export default gql`
  mutation DeleteDocument(
    $courseId: String!
    $subjectId: String!
    $documentId: String!
  ) {
    document(
      courseId: $courseId
      subjectId: $subjectId
      documentId: $documentId
    )
      @rest(
        type: "Document"
        path: "courses/{args.courseId}/subjects/{args.subjectId}/documents/{args.documentId}"
        method: "DELETE"
      ) {
      ...Document
    }
  }
  ${documentFragment}
`;
